import React from "react";
import { Row, Col, Drawer, Button } from "antd";
import commonStyles from "../DashBoardMobile/DashBoardMobile.module.scss";
import { useBillingHistoryFilterActions } from "../../../hooks/useBillingHistoryFilterActions";

type Props = {
  isOpenFilter: boolean;
  setIsOpenFilter: React.Dispatch<React.SetStateAction<boolean>>;
  onFilterCount: Function;
};

const BillingHistoryFilterDrawer: React.FC<Props> = ({
  isOpenFilter,
  setIsOpenFilter,
  onFilterCount,
}) => {
  const {
    transactionTypesOptions,
    checkedTransactionTypes,
    handleApplyFilters,
    handleReset,
    handleTransactionTypesClick,
  } = useBillingHistoryFilterActions(setIsOpenFilter, onFilterCount);

  const onClose = (): void => setIsOpenFilter(false);

  return (
    <>
      <Drawer
        placement="bottom"
        width={360}
        height={500}
        onClose={onClose}
        visible={isOpenFilter}
        closable={false}
      >
        <Row justify="center">
          <Col className={commonStyles.filterHeadings}>Filter By...</Col>
        </Row>
        <Row className={commonStyles.filterHeadingMargin}>
          <Col span={24} className={commonStyles.filterHeadings}>
            Service Types
          </Col>
          <Col span={24} className={commonStyles.noRipple}>
            {transactionTypesOptions.map((option) => (
              <Button
                key={option}
                onClick={() => handleTransactionTypesClick(option)}
                className={
                  checkedTransactionTypes.has(option)
                    ? commonStyles.filterCheckBtns
                    : commonStyles.filterUncheckBtns
                }
              >
                {option}
              </Button>
            ))}
          </Col>
        </Row>

        {/* TO-DO: Filter Service Users - Wanda Phase - 2 */}

        {/* <Row className={commonStyles.filterHeadingMargin}>
          <Col span={24} className={commonStyles.filterHeadings}>
            Service Users
          </Col>
          <Col span={24} className={commonStyles.noRipple}>
            {serviceUsersOptions.map((option) => (
              <Button
                key={option}
                onClick={() => handleUsersClick(option)}
                className={
                  checkedServiceUsers.has(option)
                    ? commonStyles.filterCheckBtns
                    : commonStyles.filterUncheckBtns
                }
              >
                {option}
              </Button>
            ))}
          </Col>
        </Row> */}

        <Row
          className={commonStyles.filterFooterMargin}
          justify="center"
          gutter={[10, 0]}
        >
          <Col>
            <Button onClick={handleReset} className={commonStyles.resetFilters}>
              Reset
            </Button>
          </Col>
          <Col>
            <Button
              onClick={handleApplyFilters}
              className={commonStyles.applyFilterBtn}
            >
              Apply Filters
            </Button>
          </Col>
        </Row>
      </Drawer>
    </>
  );
};

export default BillingHistoryFilterDrawer;
